<template>
  <Card>
    <p slot="title">
      <Icon type="md-alert" />
      钱包导入列表
    </p>
    <template slot="extra">
      <Button type="primary" icon="md-add" @click="visible = true"
        >批量充值申请</Button
      >
      <Button type="primary" icon="md-add" @click="visible = true"
        >批量回撤申请</Button
      >
      <Button type="primary" icon="md-download" @click="downloadFile()"
        >下载模板</Button
      >
      <Button
        type="primary"
        icon="md-sync"
        @click="resetList()"
        v-access="'walletImport.reset'"
        >刷新</Button
      >
    </template>
    <Row>
      <Col span="18">
        <DatePicker
          type="daterange"
          :options="options"
          placement="bottom-start"
          placeholder="请选择时间"
          v-model="seTime"
          class="public-inp"
        ></DatePicker>
        <Select v-model="status" placeholder="请选择状态" class="public-inp">
          <Option value="">全部</Option>
          <Option value="0">待审核</Option>
          <Option value="1">已审核</Option>
          <Option value="2">弃用</Option>
        </Select>
      </Col>
      <Col span="6">
        <Button
          class="public-fr"
          type="primary"
          icon="ios-search"
          @click="getList()"
          v-access="'walletImport.query'"
          >查询</Button
        >
      </Col>
      <Col span="24">
        <Table
          :style="{ marginTop: '10px' }"
          border
          stripe
          :loading="loading"
          :columns="columns"
          :data="tbList"
        >
          <template slot-scope="{ row, index }" slot="sort">
            <span v-show="false">{{ row.code }}</span>
            {{ (page - 1) * pageSize + index + 1 }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <Poptip
              v-access="'walletImport.edit'"
              v-if="row.status == 0"
              :title="row.retName"
              transfer
              placement="left"
            >
              <a>审核</a>
              <div slot="content">
                <Button type="success" size="small" @click="examine(row, 1)"
                  >同意</Button
                >
                <Button type="error" size="small" @click="examine(row, 2)"
                  >拒绝</Button
                >
              </div>
            </Poptip>
          </template>
        </Table>
        <Page
          :total="total"
          :page-size="pageSize"
          :current="page"
          show-sizer
          show-total
          prev-text="上一页"
          next-text="下一页"
          show-elevator
          @on-change="pageChange"
          @on-page-size-change="pageSizeChange"
          class="public-page"
        />
      </Col>
      <Modal
        v-model="visible"
        title="批量申请"
        :loading="formModalLoading"
        :mask-closable="false"
        @on-ok="handleSubmit"
        @on-cancel="handleReset"
      >
        <Form
          :style="{ width: '400px', margin: '0 auto' }"
          ref="formValidate"
          :model="formInline"
          :rules="ruleValidate"
          :label-width="100"
        >
          <FormItem label="文件上传" prop="url">
            <Upload
              ref="upload"
              :show-upload-list="false"
              :action="uploadUrl"
              :data="uploadPram"
              :before-upload="beforeUpload"
              :on-success="onSuccess"
              :on-error="onError"
              :max-size="20480000"
              :headers="{ token: $sessionToken() }"
            >
              <Button icon="ios-cloud-upload-outline" :loading="uploading">{{
                fileName
              }}</Button>
            </Upload>
          </FormItem>
        </Form>
      </Modal>
    </Row>
  </Card>
</template>
<script>
import axios from "axios";
const columns = [
  {
    title: "序号",
    slot: "sort",
    width: 60,
  },
  {
    title: "门店",
    key: "retName",
  },
  {
    title: "平台",
    key: "platformName",
  },
  {
    title: "导入时间",
    key: "createTime",
  },
  {
    title: "执行时间",
    key: "auditTime",
  },
  {
    title: "变动金额",
    key: "amount",
  },
  {
    title: "状态",
    key: "status",
    render: (h, params) => {
      let s = params.row.status;
      let t = s == 0 ? "待审核" : s == 1 ? "已审核" : "弃用";
      return h("span", t);
    },
  },
  {
    title: "操作",
    slot: "action",
    width: 150,
  },
];
const options = {
  shortcuts: [
    {
      text: "1 week",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        return [start, end];
      },
    },
    {
      text: "1 month",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        return [start, end];
      },
    },
    {
      text: "3 months",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        return [start, end];
      },
    },
  ],
};
export default {
  data() {
    return {
      loading: false,
      options,
      seTime: [],
      status: "",
      columns,
      tbList: [],
      total: 0,
      page: 1,
      pageSize: 10,
      visible: false,
      formModalLoading: true,
      uploadUrl: "",
      uploadPram: {
        fileType: "WALLET_ACCOUNT_BALANCE_TEMPLATE",
      },
      formInline: {
        fileId: "",
        url: "",
      },
      ruleValidate: {
        url: [{ required: true, message: "Excel不能为空", trigger: "change" }],
      },
      uploading: false,
      fileName: "上传Excel",
      templatePath:
        "https://eln-public.oss-cn-shanghai.aliyuncs.com/dev/7c24254b-e367-407a-ab69-3594c82c7ee2.xlsx",
    };
  },
  created() {
    this.uploadUrl = axios.defaults.baseURL + "base/template/uploadFile";
    this.getList();
    this.getTemplate();
  },
  methods: {
    getTemplate() {
      this.$api
        .templateFile({ fileType: "WALLET_ACCOUNT_BALANCE_TEMPLATE" })
        .then((res) => {
          if (res.code == "200") {
            this.templatePath = res.data;
          }
        });
    },
    // 列表
    getList() {
      let data = {
        accType: 0,
        transDirect: 0,
        beginDate: this.initTime(this.seTime, 0),
        endDate: this.initTime(this.seTime, 1),
        status: this.status,
        page: this.page,
        pageSize: this.pageSize,
      };
      this.loading = true;
      this.$api.balanceImportSearch(data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          this.tbList = res.data;
          this.total = res.total;
        }
      });
    },
    initTime(t, i) {
      if (!t[i]) {
        return "";
      }
      let d = t[i];
      let str = new Date(d);
      return this.tools.formatDate(str);
    },
    // 页码
    pageChange(d) {
      this.page = d;
      this.getList();
    },
    // 页数
    pageSizeChange(d) {
      this.pageSize = d;
      this.getList();
    },
    // 重置
    resetList() {
      this.seTime = [];
      this.status = "";
      this.page = 1;
      this.pageSize = 10;
      this.$nextTick(() => {
        this.getList();
      });
    },
    downloadFile() {
      let url = this.templatePath;
      try {
        var elemIF = document.createElement("iframe");
        elemIF.src = url;
        elemIF.style.display = "none";
        document.body.appendChild(elemIF);
      } catch (e) {
        this.$Message.error("下载异常！");
      }
    },
    examine(r, i) {
      let data = {
        id: r.id,
        status: i,
      };
      this.$api.balanceAudit(data).then((res) => {
        if (res.code == "200") {
          this.getList();
        }
      });
    },
    beforeUpload(d) {
      let types = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ];
      if (types.indexOf(d.type) == -1) {
        this.$Message.error("请上传Excel文件");
        return false;
      }
      this.uploading = true;
      this.fileName = d.name;
    },
    onSuccess(response, file, fileList) {
      this.uploading = false;
      if (response.code == "200") {
        this.formInline.fileId = response.data.fileId;
        this.formInline.url = response.data.url;
      } else {
        this.$Message.error(response.message);
      }
    },
    onError() {
      this.fileName = "上传Excel";
      this.formInline.fileId = "";
      this.formInline.url = "";
      this.uploading = false;
      this.$Message.error("上传失败");
    },
    handleSubmit() {
      this.formModalLoading = false;
      this.$nextTick(() => {
        this.formModalLoading = true;
      });
      let data = this.formInline;
      if (!data.url) {
        this.$Message.error("请先上传Excel");
        return;
      }
      this.$api.batchImportAccount(data).then((res) => {
        if (res.code == "200") {
          this.fileName = "上传Excel";
          this.$Message.success(res.message);
        }
      });
    },
    handleReset() {
      this.fileName = "上传Excel";
      this.formInline.fileId = "";
      this.formInline.url = "";
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/finance/walletImport.vue